import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HelpButtonComponent} from "./help-button/help-button.component";
import {HelpContentsComponent} from "./help-contents/help-contents.component";
import {HelpContainerComponent} from "./help-container/help-container.component";
import {HelpActionBarButtons} from "./help-action-bar-buttons/help-action-bar-buttons.component";
import {HelpSidebarComponent} from "./help-sidebar/help-sidebar.component";
import {HelpStateComponent} from "./help-state/help-state.component";
import {RouterModule, Routes} from "@angular/router";
import {InlineSVGModule} from "ng-inline-svg-2";
import {NgArrayPipesModule} from "ngx-pipes";
import {FormsModule} from "@angular/forms";
import {EditorModule} from "@tinymce/tinymce-angular";
import {CommonSharedModule} from "../common-shared.module";
import {TranslocoModule} from "@jsverse/transloco";
import {HelpTooltipButtonComponent} from './help-tooltip-button/help-tooltip-button.component';
import {NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  declarations: [
    HelpActionBarButtons,
    HelpButtonComponent,
    HelpContainerComponent,
    HelpContentsComponent,
    HelpSidebarComponent,
    HelpStateComponent,
    HelpTooltipButtonComponent,
  ],
  exports: [
    HelpButtonComponent,
    HelpTooltipButtonComponent
  ],
  imports: [
    CommonModule,
    CommonSharedModule,
    EditorModule,
    FormsModule,
    InlineSVGModule,
    NgArrayPipesModule,
    NgbTooltipModule,
    RouterModule,
    TranslocoModule
  ]
})
export class HelpModule {
}

export function getHelpRoutes(): Routes {
  return [
    {
      path: 'help/:helpId',
      data: {
        breadcrumb: 'Help',
        search: {
          advanced: false,
          enabled: false
        }
      },
      children: [
        {
          path: '',
          component: HelpStateComponent,
          data: {
            actionbar: false
          }
        }
      ]
    },
    {path: 'help', redirectTo: 'help/', pathMatch: 'full'}
  ]
}
